import { render, staticRenderFns } from "./counterparty_items.vue?vue&type=template&id=15e05371&scoped=true&"
import script from "./counterparty_items.vue?vue&type=script&lang=js&"
export * from "./counterparty_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e05371",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e05371')) {
      api.createRecord('15e05371', component.options)
    } else {
      api.reload('15e05371', component.options)
    }
    module.hot.accept("./counterparty_items.vue?vue&type=template&id=15e05371&scoped=true&", function () {
      api.rerender('15e05371', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/counterparty/counterparty_items.vue"
export default component.exports